var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"obflink",class:_vm.className,attrs:{"id":_vm.idName,"data-href":_vm.dataHref}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }